export default function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime/helpers/esm/iterableToArray.js
// module id = 769
// module chunks = 121